import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationHU from './locales/hu/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    hu: {
        translation: translationHU
    }
};

const savedLang = localStorage.getItem('i18nextLng') || 'hu';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: savedLang,
        fallbackLng: savedLang,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
